module.exports = __webpack_public_path__ + "static/img/google.20a27202.png";